<template>
  <div class="pagination-container">
    <nav class="pagination" aria-label="Page navigation">
      <button 
        @click="$emit('prev')" 
        :disabled="currentPage === 1" 
        class="pagination-button prev-button"
        aria-label="Previous page">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Previous</span>
      </button>
      
      <div class="page-indicator glass">
        <span class="page-label">Page</span>
        <span class="page-number">{{ currentPage }}</span>
      </div>
      
      <button 
        @click="$emit('next')" 
        :disabled="!hasMore" 
        class="pagination-button next-button"
        aria-label="Next page">
        <span>Next</span>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </nav>
  </div>
</template>

<script>
 /* eslint-disable */
export default {
  name: 'Pagination',
  props: {
    currentPage: Number,
    hasMore: Boolean,
  },
};
</script>

<style scoped>
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-3xl) var(--spacing-lg);
  animation: fadeIn 0.6s ease-out;
}

.pagination {
  display: flex;
  align-items: center;
  gap: var(--spacing-lg);
}

.pagination-button {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-md) var(--spacing-xl);
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-full);
  color: var(--text-primary);
  font-size: var(--font-size-base);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-base);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.pagination-button:not(:disabled):hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(102, 126, 234, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
}

.pagination-button:not(:disabled):active {
  transform: translateY(0);
}

.pagination-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.05);
}

.pagination-button svg {
  transition: transform var(--transition-base);
}

.prev-button:not(:disabled):hover svg {
  transform: translateX(-4px);
}

.next-button:not(:disabled):hover svg {
  transform: translateX(4px);
}

.page-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--spacing-md) var(--spacing-xl);
  border-radius: var(--radius-xl);
  min-width: 100px;
}

.page-label {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: var(--spacing-xs);
}

.page-number {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  background: var(--primary-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Responsive Design */
@media (max-width: 768px) {
  .pagination-container {
    padding: var(--spacing-2xl) var(--spacing-md);
  }

  .pagination {
    gap: var(--spacing-md);
  }

  .pagination-button {
    padding: var(--spacing-sm) var(--spacing-lg);
    font-size: var(--font-size-sm);
  }

  .page-indicator {
    padding: var(--spacing-sm) var(--spacing-lg);
    min-width: 80px;
  }

  .page-number {
    font-size: var(--font-size-xl);
  }
}

@media (max-width: 480px) {
  .pagination-container {
    padding: var(--spacing-xl) var(--spacing-sm);
  }

  .pagination {
    gap: var(--spacing-sm);
  }

  .pagination-button span {
    display: none;
  }

  .pagination-button {
    padding: var(--spacing-sm);
    min-width: 44px;
    justify-content: center;
  }

  .page-indicator {
    min-width: 70px;
  }
}
</style>